import { usePageContext } from '@merchant-portal/framework';
import { hooks as i18nHooks } from 'mage-i18n';
import { TrackImpression } from 'mage-insights';
import React, { useEffect } from 'react';
import useSetBoostersHomeSubmenu from '../../../../../hooks/useSetBoostersHomeSubmenu';
import { usePlugin } from '../hooks/usePlugin';
import AccessBanner from './AccessBanner';
import Instructions from './Instructions';
import LoaderOverlay from './LoaderOverlay';
import MidSelector from './MidSelector';
export default function Page() {
    const setBoostersHomeSubmenu = useSetBoostersHomeSubmenu();
    const t = i18nHooks.useTranslator();
    const { pluginName, pluginId } = usePlugin();
    const { setPageContext = () => { } } = usePageContext();
    useEffect(() => {
        setPageContext({
            title: t('home-fe.boosters-plugin.title', { pluginName }),
            description: t('home-fe.boosters-plugin.description'),
            backNavigation: {
                label: t('home-fe.boosters-plugins.title'),
                path: '/boost/plugins'
            }
        });
    }, [t, setPageContext]);
    const event = {
        category: `boost-home/plugin-guide/${pluginId}`,
        action: 'impression'
    };
    useEffect(() => {
        setBoostersHomeSubmenu();
    }, [setBoostersHomeSubmenu]);
    return (React.createElement(TrackImpression, { event: event },
        React.createElement("div", { id: 'boost-plugin-page' },
            React.createElement(MidSelector, null),
            React.createElement(AccessBanner, null),
            React.createElement(Instructions, null),
            React.createElement(LoaderOverlay, null))));
}
